/**
 * Expected-error tagging for user-facing CLI failures.
 *
 * A leaf module (no imports) so any module — parser, auth, commands — can tag
 * an error without pulling in the YAML parser graph or risking an import
 * cycle (mirrors `network-error.ts` / `mask-secrets.ts`).
 *
 * `isExpected` is the CLI's classification seam: `shouldReportToSentry`
 * (lib/sentry.ts) drops flagged errors, keeping routine user-actionable
 * conditions — invalid local config, a rejected sync, "run `wayai login`" —
 * out of Sentry/autofix while the message still prints to the terminal.
 */

/** Tag an Error as an expected user-facing condition (kept off Sentry). */
export function expected(message: string): Error {
  const err = new Error(message);
  (err as Error & { isExpected: boolean }).isExpected = true;
  return err;
}
